import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../utils/api';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();

  const [form, setForm] = useState({ password: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) {
      return setError('Die Passwörter stimmen nicht überein.');
    }
    if (form.password.length < 8) {
      return setError('Das Passwort muss mindestens 8 Zeichen lang sein.');
    }
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(form.password)) {
      return setError('Das Passwort muss Groß-, Kleinbuchstaben und eine Zahl enthalten.');
    }
    setLoading(true);
    setError('');
    try {
      await api.post('/auth/mosque/reset-password', { token, password: form.password });
      setDone(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Ungültiger oder abgelaufener Link.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: 24 }}>
        <div style={{ textAlign: 'center', color: 'var(--text2)' }}>
          <p>Ungültiger Link.</p>
          <Link to="/login" style={{ color: 'var(--primary)' }}>Zurück zum Login</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg)',
      padding: 24,
    }}>
      <div style={{
        width: '100%',
        maxWidth: 420,
        background: 'var(--card)',
        borderRadius: 16,
        padding: '40px 36px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <h1 style={{ fontFamily: 'Playfair Display', fontSize: 32, color: 'var(--primary-dk)', letterSpacing: -1, margin: '0 0 4px' }}>
            Ilmi<span style={{ color: 'var(--accent)' }}>fy</span>
          </h1>
          <p style={{ color: 'var(--text2)', fontSize: 14, margin: 0 }}>Neues Passwort festlegen</p>
        </div>

        {done ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: 56, height: 56, borderRadius: '50%',
              background: 'var(--primary-lt)', color: 'var(--primary)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 20px', fontSize: 24,
            }}>
              ✓
            </div>
            <h3 style={{ margin: '0 0 10px', color: 'var(--text)' }}>Passwort wurde geändert</h3>
            <p style={{ color: 'var(--text2)', fontSize: 14 }}>Sie werden in Kürze zum Login weitergeleitet…</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && (
              <div style={{
                background: 'var(--error-lt)', color: 'var(--error)',
                border: '1px solid var(--error)', borderRadius: 8,
                padding: '10px 14px', marginBottom: 16, fontSize: 14,
              }}>
                {error}
              </div>
            )}

            <div className="form-group">
              <label className="form-label">Neues Passwort</label>
              <input
                type="password"
                className="form-input"
                value={form.password}
                onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                placeholder="Mindestens 8 Zeichen"
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label className="form-label">Passwort bestätigen</label>
              <input
                type="password"
                className="form-input"
                value={form.confirm}
                onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))}
                placeholder="Passwort wiederholen"
                required
              />
            </div>

            <button type="submit" className="btn btn-primary w-full" disabled={loading} style={{ marginTop: 8 }}>
              {loading ? 'Wird gespeichert…' : 'Passwort speichern'}
            </button>

            <div style={{ textAlign: 'center', marginTop: 20 }}>
              <Link to="/login" style={{ color: 'var(--text3)', fontSize: 14, textDecoration: 'none' }}>
                ← Zurück zum Login
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
